import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAirModal } from "@air/provider-modal";
import { useToasts } from "@air/provider-toast";
import { useFlags } from "launchdarkly-react-client-sdk";
import { memo } from "react";
import { EmailSignUpChecker } from "~/components/Auth/EmailSignUpChecker";
import { DividerText } from "~/components/DividerText";
import { SamlSSOLoginModal } from "~/components/Modals/SamlSSOLoginModal";
import { SSOButtons } from "~/components/SSOButtons";
export const SignUpModalSSOOrEmailForm = /*#__PURE__*/ memo((param)=>{
    let { onEmailSubmit, ssoCallbackData, accountCreationSource, onLoginClick, closeModal } = param;
    const { showToast } = useToasts();
    const [showSAMLSSOModal] = useAirModal(SamlSSOLoginModal);
    const { maintenanceModeJson } = useFlags();
    const openSAMLSSOModal = ()=>{
        closeModal();
        // add a short delay to avoid blinking when one modal is closing, and the second one appears
        setTimeout(()=>showSAMLSSOModal({
                onShowLoginClick: onLoginClick,
                ssoCallbackData,
                customState: {
                    creationSource: accountCreationSource
                }
            }), 200);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            ssoCallbackData && /*#__PURE__*/ _jsx(SSOButtons, {
                verbText: "Sign up",
                ssoCallbackData: ssoCallbackData,
                onContinueWithSamlClick: openSAMLSSOModal,
                customState: {
                    creationSource: accountCreationSource
                }
            }),
            /*#__PURE__*/ _jsx(DividerText, {}),
            /*#__PURE__*/ _jsx(EmailSignUpChecker, {
                onSuccess: (param)=>{
                    let { email } = param;
                    onEmailSubmit(email);
                },
                onError: ()=>{
                    showToast("Something went wrong. Please try again later.");
                },
                disabled: maintenanceModeJson === null || maintenanceModeJson === void 0 ? void 0 : maintenanceModeJson.maintenanceMessage
            })
        ]
    });
});
SignUpModalSSOOrEmailForm.displayName = "SignUpModalSSOOrEmailForm";
